module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/slogan.84d50.png";